import { inject, Injectable, OnDestroy } from '@angular/core';

import { FeatureAnnouncementStoreService } from '@customer-portal/data-access/feature-announcements';

import { FeatureAnnouncementBadgeRendererService } from './feature-announcement-badge-renderer.service';

@Injectable({ providedIn: 'root' })
export class FeatureAnnouncementBootstrapService implements OnDestroy {
  private initialized = false;
  private readonly announcementStore = inject(FeatureAnnouncementStoreService);
  private readonly badgeRenderer = inject(
    FeatureAnnouncementBadgeRendererService,
  );

  initialize(): void {
    if (this.initialized) {
      return;
    }

    this.initialized = true;
    this.badgeRenderer.initialize();
    this.announcementStore.loadFeatureAnnouncements();
  }

  ngOnDestroy(): void {
    this.initialized = false;
  }
}
